/**
 * Fork extension point for the CRUD framework — the ONLY file this fork edits to
 * register private field/column widget *types* for @greenhouse/crud.
 *
 * app.tsx calls registerCrudExtensions() once at startup, so these widgets are
 * available to any schema via `{ type: 'extension', name: '...' }` WITHOUT
 * editing the framework core.
 *
 * `richtext` — minimal HTML/Markdown editor backing the dashboard FAQ/blog
 * content fields. A real EditorJS/image-upload widget slots in the same way
 * (register another name here); the letpot dashboard uses `richtext` today.
 */

import { createElement } from 'react';
import { registerCrudField, type CrudFieldRenderProps } from '@greenhouse/crud';
import { Textarea } from '../components/ui';

function RichTextField({ value, onChange, disabled, placeholder, config }: CrudFieldRenderProps) {
  const rows = typeof config?.minRows === 'number' ? config.minRows : 6;
  return createElement(Textarea, {
    value: (value as string) ?? '',
    rows,
    disabled,
    placeholder: placeholder ?? 'HTML or Markdown…',
    className: 'font-mono text-xs',
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value),
  });
}

/** Register private CRUD field/column widget types. */
export function registerCrudExtensions(): void {
  registerCrudField('richtext', RichTextField);
}
